<template>
  <v-app>
    <router-view></router-view>
    <v-snackbar
      :color="snackbar.color"
      v-model="snackbar.show"
      class="text-center"
    >
      <h3 class="font-weight-light">{{ snackbar.text }}</h3>
      <template v-slot:action="{ attrs }">
        <v-btn icon @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { languages } from "@/plugins/languages";
export default {
  name: "App",
  mounted() {
    let config = this.$store.state.config;
    let user = this.$store.state.user;
    if (config === undefined) {
      return;
    }
    let template_settings_theme = config.template_settings.theme;
    if (template_settings_theme !== undefined) {
      this.$vuetify.theme.themes.light.primary = template_settings_theme;
    }
    this.$i18n.locale = languages[user.site_language]
      ? languages[user.site_language]
      : "nl";
    const styleEl = document.createElement("style");
    styleEl.innerHTML = this.$store.state.config.template_settings.custom_css;
    document.head.appendChild(styleEl);
  },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: "error"
    }
  }),
  computed: {
    snackbarTrigger() {
      return this.$store.state.viewstate.notificationSnackbar.trigger;
    }
  },
  watch: {
    snackbarTrigger: function() {
      let globalSnackbar = this.$store.state.viewstate.notificationSnackbar;
      this.snackbar = {
        show: true,
        text: globalSnackbar.text,
        color: globalSnackbar.color
      };
    }
  }
};
</script>

<style>
/** Change datatable margin to fit around 352 max width */
.v-application--is-ltr .v-data-footer__select {
  margin-right: 0px;
}
.v-application--is-ltr .v-data-footer__pagination {
  margin: 0 5px;
}
.v-application--is-ltr .v-data-footer__select .v-select {
  margin: 5px 0 5px 5px;
}
/** end datatable margin changes */

.no-text-transform {
  text-transform: none !important;
}
</style>
